<template>

<div ref="filterDropdown" class="filter-dropdown">
    <div class="dropdown-labelled">
        <em class="labelled__error js-labelled__error" role="alert"
            :id="`dropdown-labelled-edit-${hyphenedType}__error`">Error: </em>
        <label :for="`edit-${hyphenedType}`" class="visually-hidden">{{listLabel}}</label>
        <div class="dropdown__wrapper">
            

            <select @change="onChange($event)"
                    :data-drupal-selector="`edit-${hyphenedType}`"
                    :id="`edit-${hyphenedType}`"
                    name="type"
                    class="form-select dropdown__input js-dropdown__input">
                <option value="1" :selected="searchSelectedFilters[filter] == null ? 'selected' : 0">{{optionType}}</option>
                <option v-for="option in options"
                        v-bind:key="option.identifier"
                        :value="option.name"
                        :selected="searchSelectedFilters[filter] == option.name ? 'selected' : ''">
                        {{ option.alternate_name ? option.alternate_name : option.name }}
                </option>
            </select>
        </div>
    </div>
</div>
</template>



<style lang="scss" scoped>
.dropdown {
    cursor: pointer;

    &:focus {
        outline: .0625rem dashed #000;
        outline-offset: .3125rem;
    }   
}

ol.cb__list { 
    position: absolute;
    top: 3.125rem;
    left: 0;
    visibility: hidden;
    overflow: auto;
    width: 100%;
    max-height: 31.25rem;
    margin: 0;
    padding: 0;
    list-style-type: none;
    border-right: .0625rem solid #232323;
    border-bottom: .0625rem solid #232323;
    border-left: .0625rem solid #232323;
    background-color: #fff;

    .cb__option {
        display: inline-block;
        width: 100%;
        height: auto;
        margin-bottom: 0;
        padding: .625rem 1.25rem;
        cursor: pointer;
        vertical-align: middle;
        color: #a11b27;

        &.selected, &:hover {
            transition: all .2s ease;
            color: #fff;
            background-color: #bb2533;
        }
    }
}

.dropdown--opened {
    ol.cb__list {
        visibility: visible;
        z-index: 10;
    }
}

.filter-dropdown:hover .dropdown:focus .cb__button::after {
    outline: .0625rem dashed #FFF;
}

.filter-dropdown {
    padding-left: 1rem;
}

@media screen and (max-width: 900px) {
    .filter-dropdown {
        padding-left: 0;
        margin-bottom: .7rem;

        .button {
            border-width: .125rem;
            padding-left: 24px;
        }
    }
}
</style>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: 'FilterDropdown',
        props: {
            "filter": String,
            "optionType": String,
            "listLabel": String,
            "options": Array,
            "searchSelectedFilters": Object,
            "autoLang": Boolean
        },
        computed: {
            ...mapGetters([
                'i18n_strings'
            ]),
            hyphenedType: function() {
                return this.optionType.toLowerCase().replace(' ', '-');
            },    
            currentLang: function () {
                return document.querySelector('html').getAttribute('lang')
            },
        },
        data: function () {
            return {
                dropdown: null
            }
        },
        watch: {
            searchSelectedFilters: {
                handler (newValue) {
                    this.input.value = (newValue[this.filter] || 1);
                },
                deep: true
            }
        },
        methods: {
            onChange: function(e) {
                let query = Object.assign({}, this.$route.query);
                const v = e.target.value;
                if(v == "1" && query[this.filter]) {
                    delete query[this.filter];
                    if (this.filter == 'languages') {
                        this.$emit('kill-auto-lang');
                    }
                } else {
                    query[this.filter] = v;

                    // set lang to html lang if none selected
                    let lang = this.currentLang;
                    if (!query['languages'] && this.autoLang) {
                        let langName = lang == 'fr' ? 'Français' : 'English';
                        query['languages'] = langName;
                    }
                }

                let lang = this.currentLang;
                let routeName = lang == 'en' ? 'search' : 'rechercher';
                this.$router.push({
                    name: routeName,
                    query: query
                }).catch(err => {
                    console.error(err);
                })
            }
        },
        mounted() {
            this.input = this.$refs.filterDropdown.querySelector('.js-dropdown__input');
        },
        updated: function(){
            if (this.filter != 'languages') return;
            var ref = this;

            this.$nextTick(function () {
                if(typeof ref.$refs.optionsList != 'undefined'){
                    if (ref.$refs.optionsList.length > 1 && this.autoLang) {
                        let lang = this.currentLang;
                        let langName = lang == 'fr' ? 'Français' : 'English';

                        let item = ref.$el.querySelector(`li[data-name="${langName}"]`);
                        ref.dropdown.setSelected(item);
                    }
                }
            })
        }
    }
</script>
